import { Card, Grid, Typography, CardActions } from "@mui/material";
import styled from "styled-components";

export const StyledMessageCard = styled(Card)`
  opacity: ${(props) => (props.isSeen ? "0.8" : "1")};
`;

export const StyledGridContainer = styled(Grid)`
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const StyledGridItem = styled(Grid)`
  direction: ltr;
`;

export const MessageBox = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: rtl;

  @media (max-width: 700px) {
    display: block !important;
  }
`;

export const StyledIconTypography = styled(Typography)`
  ${(props) =>
    props.isSeen
      ? `
    color: blue;
    font-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  `
      : `
    color: green;
    font-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.7;`}
`;

export const DeleteIconMessage = styled(CardActions)`
  width: 40px;
  height: 40px;
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  padding: 0px;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 600px) {
    width: 25px;
    height: 25px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`;
